<template>
    <div class="modal-dialog modal-full">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                <h4 class="modal-title">{{ $t('quotation') }}</h4>
            </div>
            <div class="modal-body">
                <div class="modal_content m-b-0">
                    <div class="row">
                        <div class="col-sm-5">
                            <div class="contact-card">
                                <img class="img-circle pull-left" :src="lead.avatar || '/static/images/avatar.jpg'" :alt="lead.full_name">
                                <div class="member-info">
                                    <h4 class="m-t-0 m-b-5 header-title">
                                        <b>{{ lead.full_name }}</b>
                                        <small class="show m-t-10" v-if="lead.reference">({{ lead.reference }})</small>
                                    </h4>
                                    <p class="text-muted" v-if="lead.country_id">
                                        <img alt="" class="flag_deal" :src="'/static/images/flags/' + lead.country.acronym + '.png'"> {{ lead.country.name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3 m-t-15 t_center">
                            <strong class="show">{{ $t('status') }}</strong>
                            <label class="label" :class="{
                                'label-danger': quotation.status == 'reproved',
                                'label-default': quotation.status == 'approved',
                                'label-success': quotation.status == 'sent',
                                'label-warning': quotation.status == 'new'
                            }">{{ $t(quotation.status) }}</label>
                        </div>
                        <div class="col-sm-4 t_right">
                            <p><label class="label label-inverse" v-if="quotation.number">{{ $t('number') }}: {{ quotation.number }}</label></p>
                            <a :href="`/my-quotation/${quotation.code}`" target="_blank" class="btn btn-primary">
                                <span class="btn-label">
                                    <i class="fa-fw md md-visibility"></i>
                                </span>
                                {{ $t('view_quotation') }}
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <PmlSummary :quotation="quotation"></PmlSummary>
                        <div class="col-sm-9">
                            <div class="card-box p-0 m-0">
                                <ul class="nav nav-tabs navtab-bg nav-justified tabs_quote">
                                    <router-link tag="li" :to="{ name: 'deals.show.quotations.info', params: { id: quotation.deal_id, quotation: quotation.id } }">
                                        <a><span><i class="fa fa-file-text"></i></span> <span class="hidden-sm">{{ $t('info') }}</span></a>
                                    </router-link>
                                    <router-link tag="li" :to="{ name: 'deals.show.quotations.products', params: { id: quotation.deal_id, quotation: quotation.id } }">
                                        <a><span><i class="fa fa-shopping-cart"></i></span> <span class="hidden-sm">{{ $t('products') }}</span></a>
                                    </router-link>
                                    <router-link tag="li" :to="{ name: 'deals.show.quotations.charges', params: { id: quotation.deal_id, quotation: quotation.id } }">
                                        <a><span><i class="fa fa-ticket"></i></span> <span class="hidden-sm">{{ $t('charges') }}</span></a>
                                    </router-link>
                                    <router-link tag="li" :to="{ name: 'deals.show.quotations.payments', params: { id: quotation.deal_id, quotation: quotation.id } }">
                                        <a><span><i class="fa fa-usd"></i></span> <span class="hidden-sm">{{ $t('payment_methods') }}</span></a>
                                    </router-link>
                                    <router-link tag="li" :to="{ name: 'deals.show.quotations.extra', params: { id: quotation.deal_id, quotation: quotation.id } }">
                                        <a><span><i class="fa fa-info-circle"></i></span> <span class="hidden-sm">{{ $t('additional_info') }}</span></a>
                                    </router-link>
                                </ul>
                                <div class="tab-content p-0">
                                    <router-view name="tab"></router-view>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RoutedModals from '@/utils/mixins/routed-modals'
    import PmlSummary from './Summary.vue'
    import { mapGetters } from 'vuex'
    // import { find } from 'lodash'

    export default {
        name: 'EditQuotation',
        mixins: [ RoutedModals ],
        components: { PmlSummary },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'deal': 'getDealInfo',
                'lead': 'getLeadInfo',
                'quotations': 'getDealQuotations'
            }),
            quotation () {
                let quotation = this.quotations.find((item) => item.id === parseInt(this.$route.params.quotation))

                if (typeof quotation === 'undefined')
                    this.$router.push('/deals')

                return quotation || {}
            }
        },
        watch: {
            'goBackTo' (val) {
                let path = `/deals/${this.deal.id}/quotations`
                if (val !== path)
                    this.goBackTo = path
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/Main.vue